// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3dxyC2YsNcjdjw {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  display: flex;\n  flex-direction: row;\n  background-color: #FFFFFF;\n  padding: 0 16px 8px 12px;\n  justify-content: space-between;\n  width: 404px;\n}\n.r8SzHDser4EuAi {\n  background: none;\n  border: none;\n  box-shadow: none;\n  color: #6B778C;\n  padding: 0;\n  text-decoration: underline;\n  font-weight: normal;\n}\n.r8SzHDser4EuAi:hover,\n.r8SzHDser4EuAi:focus {\n  color: #172B4D;\n  outline: none;\n  background-color: transparent;\n  box-shadow: none;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationActions": "_3dxyC2YsNcjdjw",
	"notificationAction": "r8SzHDser4EuAi"
};
export default ___CSS_LOADER_EXPORT___;
